import { render, staticRenderFns } from "./DisplayModuleSpotSource.vue?vue&type=template&id=786c2544&"
import script from "./DisplayModuleSpotSource.vue?vue&type=script&lang=ts&"
export * from "./DisplayModuleSpotSource.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
